import { render, staticRenderFns } from "./ImgProList.vue?vue&type=template&id=4b367c75&scoped=true"
import script from "./ImgProList.vue?vue&type=script&lang=js"
export * from "./ImgProList.vue?vue&type=script&lang=js"
import style0 from "./ImgProList.vue?vue&type=style&index=0&id=4b367c75&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b367c75",
  null
  
)

export default component.exports